export const propertyByString = (obj, keys) => {
    keys = keys.replace(/\[(\w+)\]/g, '.$1') // convert indexes to properties
    keys = keys.replace(/^\./, '') // strip a leading dot
    const a = keys.split('.')
    for (let i = 0, n = a.length; i < n; ++i) {
        const k = a[i]
        if (typeof obj === 'object' && obj !== null && k in obj) {
            obj = obj[k]
        } else {
            return false
        }
    }
    return obj
}
